import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Description, Title } from './OnboardingSlice';
import LeftIllustration from './assets/questions-illustration.svg';
import RightIllustration from './assets/questions-leaves.svg';
import SearchIcon from './assets/search.svg';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { tabletBreakpoint, mobileBreakpoint } from '@/src/domains/shared/breakpoints';

export const Section = styled.section`
  ${fluidProp(['padding-bottom', 'padding-top'], '80px', '110px')}
  font-family: var(--typography-fontBrand);
  position: relative;

  ${Title} {
    margin-bottom: 80px;
  }

  ${ContentContainer} {
    z-index: 1;
    position: relative;
  }
`;

export const BlockTitle = styled.div`
  ${({ theme }) => theme.typography.bodyLeadBold}
`;

export const Block = styled.div`
  width: 45%;

  ${tabletBreakpoint(css`
    width: 90%;
  `)};
`;

export const BlocksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ImageWrapper = styled.div`
  margin-bottom: 32px;
`;

export const LeftIllustrationWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;

  img {
    vertical-align: bottom;
  }

  ${mobileBreakpoint(css`
    display: none;
  `)}
`;

export const RightIllustrationWrapper = styled.div`
  position: absolute;
  top: -8%;
  right: 0;
  z-index: 0;

  ${mobileBreakpoint(css`
    display: none;
  `)}
`;

export function QuestionsSlice({ slice }) {
  const { primary, fields } = transformProperties(slice);
  const { title } = primary;

  return (
    <Section id="onboarding">
      <ContentContainer>
        {fieldHasContent(title) && (
          <>
            <SearchIcon />
            <Title>
              <PrismicRichText field={title} />
            </Title>
          </>
        )}
        <BlocksWrapper>
          {fields.map(({ illustration, reasonTitle, reasonDescription }, index) => (
            <Block key={index}>
              <ImageWrapper>
                <Image
                  src={illustration.url}
                  alt={illustration.alt || ''}
                  width={illustration.dimensions.width}
                  height={illustration.dimensions.height}
                  quality="100"
                />
              </ImageWrapper>
              {fieldHasContent(reasonTitle) && (
                <BlockTitle>
                  <PrismicRichText field={reasonTitle} />
                </BlockTitle>
              )}
              {fieldHasContent(reasonDescription) && (
                <Description>
                  <PrismicRichText field={reasonDescription} />
                </Description>
              )}
            </Block>
          ))}
        </BlocksWrapper>
      </ContentContainer>
      <LeftIllustrationWrapper>
        <LeftIllustration />
      </LeftIllustrationWrapper>
      <RightIllustrationWrapper>
        <RightIllustration />
      </RightIllustrationWrapper>
    </Section>
  );
}
